/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SisCommonModule } from 'sis-common';
import { SisComponentsModule, StudyRightModule, StudyRightStatesModule, StudyRightStatusBadgeModule } from 'sis-components';
import { CreateStudyCertificateModalComponent } from './create-study-certificate-modal/create-study-certificate-modal.component';
import { EnrolmentRightStudentStudyRightComponent } from './enrolment-right-student-study-right/enrolment-right-student-study-right.component';
import { StudyRightsComponent } from './study-rights/study-rights.component';

@NgModule({
    declarations: [StudyRightsComponent, CreateStudyCertificateModalComponent, EnrolmentRightStudentStudyRightComponent],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        SisCommonModule,
        SisComponentsModule,
        StudyRightModule,
        StudyRightStatusBadgeModule,
        StudyRightStatesModule,
    ],
})
export class StudyRightsModule {}
